/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Speed_SettingsInputs */

const en_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Speed Settings`)
};

const fr_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de vitesse de lecture`)
};

const de_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen für die Lesegeschwindigkeit`)
};

const it_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni della velocità di lettura`)
};

const ru_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки скорости чтения`)
};

const es_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de velocidad de lectura`)
};

const zh_cn2_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读速度设置`)
};

const ja_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り速度設定`)
};

const hi_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पठन गति सेटिंग्स`)
};

const pt_pt2_reading_speed_settings = /** @type {(inputs: Reading_Speed_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de velocidade de leitura`)
};

/**
* | output |
* | --- |
* | "Reading Speed Settings" |
*
* @param {Reading_Speed_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reading_speed_settings = /** @type {((inputs?: Reading_Speed_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Speed_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reading_speed_settings(inputs)
	if (locale === "de") return de_reading_speed_settings(inputs)
	if (locale === "it") return it_reading_speed_settings(inputs)
	if (locale === "ru") return ru_reading_speed_settings(inputs)
	if (locale === "es") return es_reading_speed_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_reading_speed_settings(inputs)
	if (locale === "ja") return ja_reading_speed_settings(inputs)
	if (locale === "hi") return hi_reading_speed_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_reading_speed_settings(inputs)
	return en_reading_speed_settings(inputs)
});